import Dialog from "dialog";
import template from "./dialog-config.html";
import css from "./dialog-config.css";

class ConfigO2Dialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-o2", ConfigO2Dialog);
  }
  constructor() {
    super();

    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

    this.onupdatedevices_handler({detail: application.devices});

    this.show();
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.mx200o2.id;
    this.textboxDeviceStatus.value = devices.mx200o2.status;
    this.textboxValue.value = devices.mx200o2.value;
    this.textboxInternalTemperature.value = devices.mx200o2.internalTemperature;
    this.textboxInternalBarometricPressure.value = devices.mx200o2.internalBarometricPressure;
    this.textboxOnBoardTemperature.value = devices.mx200o2.onBoardTemperature;
    this.textboxOnBoardBarometricPressure.value = devices.mx200o2.onBoardBarometricPressure;
    this.textboxOnBoardRelativeHumidity.value = devices.mx200o2.onBoardRelativeHumidity;

  }
  buttonClose_click(event) {
    this.close();
  }
  async buttonCalibrateZero_click(event) {
    try {
      this.buttonCalibrateZero.icon.iconname = "view-refresh";
      await server.rcall("RM_mx200o2_calibratezero");
      this.buttonCalibrateZero.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateZero.icon.iconname = "process-stop";
    }
  }
  async buttonCalibrateSpan_click(event) {
    try {
      this.buttonCalibrateSpan.icon.iconname = "view-refresh";
      await server.rcall("RM_mx200o2_calibratespan", parseInt(this.textboxCalibrateSpan.value));
      this.buttonCalibrateSpan.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateSpan.icon.iconname = "process-stop";
    }
  }
  close() {
    super.close();
  }
}

ConfigO2Dialog.constructor();

export default ConfigO2Dialog;